<template>
  <div
    class="diseases-statistics"
    :class="{ 'diseases-statistics--compact': compact }"
    data-qa="diseases_statistics"
  >
    <div
      class="diseases-statistics__columns d-flex ga-4"
      :class="twoColumns ? 'diseases-statistics__columns--two flex-wrap gc-6' : 'flex-column'"
      data-qa="diseases_statistics_list"
    >
      <div
        v-for="(column, columnIndex) in diseaseColumns"
        :key="columnIndex"
        class="diseases-statistics__column d-flex flex-column ga-4"
        :class="{ 'diseases-statistics__column--two flex-grow-1': twoColumns }"
      >
        <div
          v-for="(practice, i) in column"
          :key="`${columnIndex}-${i}`"
          class="diseases-statistics__item d-flex align-start"
          :class="compact ? 'ga-2' : 'ga-4'"
          data-qa="diseases_statistics_item"
        >
          <div
            class="diseases-statistics__percent d-flex align-center justify-center flex-shrink-0 primary--text bg-primary rounded"
            :class="compact ? 'text-subtitle-2 px-2 py-1' : 'text-subtitle-1 px-3 py-1'"
            data-qa="diseases_statistics_percent"
          >
            {{ practice.frequency }}%
          </div>
          <div
            v-if="practice.manipulation_type_translit"
            class="diseases-statistics__name flex-grow-1"
          >
            <a
              :href="`/${context.town.translit}/lechenie/${practice.manipulation_type_translit}/`"
              class="text-decoration-none text--text"
              :class="compact ? 'text-body-2' : 'text-body-1'"
              data-qa="diseases_statistics_name"
            >
              {{ getPracticeLabel(practice) }}
            </a>
          </div>
          <div
            v-else
            class="diseases-statistics__name flex-grow-1"
            :class="compact ? 'text-body-2' : 'text-body-1'"
            data-qa="diseases_statistics_name"
          >
            {{ getPracticeLabel(practice) }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useContextStore } from 'src/store'
import type { ContextStore } from 'src/components/pages/[town_translit]/vrach/[doctor_translit]/SectionPractice/types'

const props = withDefaults(defineProps<{
  limit?: number
  showCode?: boolean
  compact?: boolean
  twoColumns?: boolean
}>(), {
  limit: undefined,
  // eslint-disable-next-line vue/no-boolean-default
  showCode: true,
  compact: false,
  twoColumns: false,
})

const { context }: ContextStore = useContextStore()

const practiceList = computed(() => {
  const list = context.doctor_practice.mkb_practice

  if (props.limit) {
    return list.slice(0, props.limit)
  }

  return list
})

const diseaseColumns = computed(() => {
  if (!props.twoColumns) {
    return [practiceList.value]
  }

  const mid = Math.ceil(practiceList.value.length / 2)

  return [
    practiceList.value.slice(0, mid),
    practiceList.value.slice(mid),
  ]
})

function getPracticeLabel(practice: ContextStore['context']['doctor_practice']['mkb_practice'][number]) {
  if (props.showCode) {
    return `${practice.name} (${practice.code})`
  }

  return practice.name
}
</script>

<style lang="scss" scoped>
.diseases-statistics {
  min-width: 0;

  &__columns,
  &__column,
  &__item {
    min-width: 0;
  }

  &__name {
    min-width: 0;
    word-break: break-word;
  }

  &__columns--two {
    align-items: flex-start;
  }

  &__column--two {
    flex: 1 1 0;
  }

  &__percent {
    min-width: 54px;
  }

  &--compact &__percent {
    min-width: 48px;
  }
}
</style>
